import {useEffect, useState} from "react";
import {Button, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DataRange from "./DataRange";
import moment from "moment";
// -
import DateUtils from "core/utils/DateUtils";
import ButtonGroup from "react-bootstrap/ButtonGroup";

const DropdownDateRange = ({size = "lg", dateRange, setDateRange, maxDays, range = 7}) => {
    const [dateRangeLabel, setDateRangeLabel] = useState(
        moment().subtract(range, "days").format("DD-MM-YYYY") + " | " + moment().format("DD-MM-YYYY"),
    );

    const selectDateRange = (startDate, endDate) => {
        setDateRangeLabel(DateUtils.dateToStringSpanish(startDate) + " / " + DateUtils.dateToStringSpanish(endDate));
        setDateRange({startDate, endDate});
    };
    const clearDateRange = (e) => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - range);
        setDateRangeLabel(DateUtils.dateToStringSpanish(startDate) + " / " + DateUtils.dateToStringSpanish(endDate));
        setDateRange({startDate, endDate});
    };

    return (
        <ButtonGroup className="w-100" size={size}>
            <Dropdown className="w-100" size={size}>
                <Dropdown.Toggle
                    variant="Secondary"
                    id="dropdown-basic"
                    style={{border: "1px solid #ced4da", minWidth: "100%"}}
                    className="custom-dropdown-toggle"
                    size={size}>
                    <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                    <label style={{width: "90%", textAlign: "center"}}> {dateRangeLabel}</label>
                </Dropdown.Toggle>
                <Dropdown.Menu size={size}>
                    <DataRange rangeData={selectDateRange} maxDate={new Date()} maxSpan={maxDays} />
                </Dropdown.Menu>
            </Dropdown>
            <Button type="button" variant="link" className="text-black" onClick={clearDateRange} title="Limpiar fechas">
                <FontAwesomeIcon icon="xmark" />
            </Button>
        </ButtonGroup>
    );
};
export default DropdownDateRange;
